export const msalConfig = {
    auth: {
        clientId: process.env.MSAL_CLIENT_ID ?? '',
        authority: `https://login.microsoftonline.com/${process.env.MSAL_TENANT_ID ?? "90c419c1-acb3-4278-a5a2-e268c23890fd"}`,
        redirectUri: '/sso-auth',
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
};
